// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'robot';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.96 6.768h10.152c.864 0 1.512.648 1.512 1.512v7.488c0 .864-.648 1.512-1.512 1.512H3.96c-.864 0-1.512-.648-1.512-1.512V8.28c0-.864.648-1.512 1.512-1.512zM.576 10.512v3.384m16.848-3.384v3.384m-11.808.792h6.768M9 6.768V4.464m0 0A1.872 1.872 0 1 0 9 .72a1.872 1.872 0 0 0 0 3.744z' />
    <path d='M5.976 11.736a1.152 1.152 0 1 0 0-2.304 1.152 1.152 0 0 0 0 2.304zm6.048 0a1.152 1.152 0 1 0 0-2.304 1.152 1.152 0 0 0 0 2.304z' />
  </g>
);

export const viewBox = '0 0 18 18';
